<template src="./template.html" />

<script>

import LandingPages from 'src/modules/pages/landing-page'
import { canInCollection } from 'naf-acl'
import FilterBox from '@/components/filter-box'
const DEFAULT_FILTER = [['@deleted', '==', false]]
const DEFAULT_ORDER = ['metaData.lastModifiedTime', 'desc']
import StringUtils from 'utils/StringUtils'
export default {
  name: 'ManageStaff',
  components: {
    LandingPages,
    FilterBox
  },
  data () {
    return {
      DEFAULT_FILTER: DEFAULT_FILTER,
      DEFAULT_ORDER: DEFAULT_ORDER,
      defaultQuery: {
        ref: ['StaffInformation'],
        filter: DEFAULT_FILTER,
        order: DEFAULT_ORDER,
        limit: 50,
        returnSnapshot: true
      },
      queryConditions: {
        ref: ['StaffInformation'],
        filter: DEFAULT_FILTER,
        order: DEFAULT_ORDER,
        limit: 50,
        returnSnapshot: true 
      },
      tableConfig: {
        pagination: {
          'rowsPerPage': !this.$q.screen.gt.xs ? 30 : 50,
          'rowsNumber': 50,
          'descending': true,
          'sortBy': 'metaData.lastModifiedTime'
        }
      },
      headers: [
        {
          label: 'No',
          align: 'left',
          sortable: false,
          name: 'no'
        },
        {
          label: 'Mã số NV',
          align: 'left',
          name: 'staffID',
          field: 'staffID'
        },
        {
          label: 'Công ty',
          align: 'left',
          name: 'company',
          field: 'company',
          labelFormat: `$this && $this.label ? $this.label: ''`
        },
        {
          label: 'Trạng thái làm việc',
          align: 'left',
          name: 'workingStatus',
          field: 'workingStatus',
          labelFormat: `$this && $this.label ? $this.label: ''`
        },
        {
          label: 'Họ tên',
          align: 'left',
          name: 'name',
          field: 'name',
        },
        {
          label: 'Giới tính',
          align: 'left',
          name: 'gender',
          field: 'gender',
          labelFormat: `$this ? 'Nam' : 'Nữ'`
        },
        {
          label: 'Số điện thoại',
          align: 'left',
          name: 'tel',
          field: 'tel'
        },
        {
          label: 'Email công ty',
          align: 'left',
          name: 'companyEmail',
          field: 'companyEmail'
        },
        {
          label: 'Họ tên người quản lý trực tiếp',
          align: 'left',
          name: 'departments',
          field: 'departments',
          labelFormat: `$this ? $this.nameDirectManager : ''`
        },
        {
          label: 'Ngày làm việc đầu tiên',
          align: 'left',
          name: 'departments.firstDayWork',
          field: 'departments',
          labelFormat: `$this && $this.firstDayWork && $this.firstDayWork.toDate ? moment($this.firstDayWork.toDate()).format('DD/MM/YYYY') : ''`
        },
        {
          label: 'Ngày làm việc sau cùng',
          align: 'left',
          name: 'lastWorkingDate',
          field: 'lastWorkingDate',
          labelFormat: `$this && $this && $this.toDate ? moment($this.toDate()).format('DD/MM/YYYY') : ''`
        }
      ],
      landingPagesConfig: {
        backLink: '/human-resources',
        routeDetailName: '/human-resources/staff-information/detail',
        canCopy: false
      },
      masterdata: null,
      canQuery: false,
      disableFreeText: false,
      conditions: [
        {//0 dep
          config: {
            datasource: {
              options: [],
              label: 'name',
              value: 'id',
              emitValue: true
            },
            fieldName: 'department',
            mapOptions: true,
            sortBy: 'name',
            label: 'Phòng ban',
            clearable: true,
            icon: 'store'
          },
          mapLabel: ['id', 'name'],
          query: ['departments.dep.id', '==', 'this']
        },
        {//1 status
          config: {
            datasource: {
              options: [],
              label: 'label',
              value: 'value',
              emitValue: true
            },
            fieldName: 'workingStatus',
            mapOptions: true,
            sortBy: 'name',
            label: 'Trạng thái làm việc',
            clearable: true,
            icon: 'store',
          },
          mapLabel: ['value', 'label'],
          query: ['workingStatus.value', '==', 'this']
        },
        {//2 level
          config: {
            datasource: {
              options: [],
              label: 'label',
              value: 'value',
              emitValue: true
            },
            fieldName: 'level',
            mapOptions: true,
            sortBy: 'name',
            label: 'Cấp bậc',
            clearable: true,
            icon: 'store',
          },
          mapLabel: ['value', 'label'],
          query: ['departments.level.value', '==', 'this']
        }
      ],
      conditionsFreeText: {
        config: {
          label: 'Tên/ Mã nhân viên',
          fieldName: 'name'
        },
        query: ['metaData.search', 'array-contains', 'this']
      }
    }
  },
  created() {
    this.filterByCompany()
    this.fetchMasterData()
    this.recoverFilter()
  },
  computed: {
    canCreateComputed() {
      if(this.$store.getters.permission) {
        let userProfile = this.$store.getters.permission
        let groups = this.R.path(['groups'], userProfile)
        let level = this.R.path(['level', 'value'], userProfile)
        let dep = this.R.path(['dep', 'id'], userProfile)
        let title = this.R.path(['title'], userProfile) || ''
        return canInCollection('create', 'StaffInformation') ||
        this.R.includes('admin', groups) || this.R.includes('bom', groups) || this.R.includes(level, ['bom', 'manager', 'lead', 'assistant']) || 
        (dep === 'HR' && (title.trim().toLowerCase() === 'nhân viên nhân sự' || title.trim().toLowerCase() === 'chuyên viên nhân sự'))
      }
      return canInCollection('create', 'StaffInformation') || false
    }
  },
  methods: {
    filterByCompany() {
      if(this.$store.getters.permission) {
        let userProfile = this.$store.getters.permission
        let groups = this.R.path(['groups'], userProfile)
        let level = this.R.path(['level', 'value'], userProfile)
        let dep = this.R.path(['dep', 'id'], userProfile)
        let company = this.R.path(['company', 'value'], userProfile)
        let title = this.R.path(['title'], userProfile) || ''
        if(this.R.includes('admin', groups) || this.R.includes('bom', groups) || this.R.includes(level, ['bom', 'manager', 'lead', 'assistant']) || 
        (dep === 'HR' && (title.trim().toLowerCase() === 'nhân viên nhân sự' || title.trim().toLowerCase() === 'chuyên viên nhân sự'))) {
          if(company !== 'nafoodsGroup') {
            this.queryConditions.filter = this.R.append(['company.value', '==', company], this.queryConditions.filter)
            this.DEFAULT_FILTER = this.R.clone(this.queryConditions.filter)
          }
          this.canQuery = true
          return
        }
      }

    },
    recoverFilter() {
      // if(!this._.isEmpty(this.$store.getters.hr.staffInfo.filter)){
      //   this.entitySelector = this.R.mergeDeepRight(this.entitySelector, this.$store.getters.hr.staffInfo.filter)
      //   this.search()
      // }
    },
    async handlerDetail (id) {
      let vm = this
      let dataFetched = await this.$query(['StaffInformation', id])
      this.$router.push({
        name: vm.landingPagesConfig.routeDetailName,
        query: {
          id: id
        },
        params: {
          id: id,
          mode: 'EDIT',
          data: dataFetched
        }
      })
    },
    async handlerDelete (payload, resolve, reject) {
      let vm = this
      let submitModel = { id: payload._id, data: vm._.omit(payload, '_id', '__index') }
      await vm.$command.execute('deleteStaffInformation', submitModel).then(() => resolve('resolved')).catch(err => reject(err))
    },
    handlerAddButtonClick () {
      let vm = this
      vm.$router.push({ name: vm.landingPagesConfig.routeDetailName, params: { mode: 'CREATE' } })
    },
    canInCollection,
    query(value) {
      // let hrState = { staffInfo: {
      //   filter: {}
      // }}
      // hrState.staffInfo.filter = this._.cloneDeep(this.entitySelector)
      // this.$store.dispatch('registerHRState', hrState)
      this.queryConditions = value
      if(this.$refs.landingPage) {
        this.$refs.landingPage.$emit('updateQueryConditions', this.queryConditions)
        this.$refs.landingPage.$emit('fetchData')
      }
    },
    fetchMasterData() {
      this.$query(['MasterData', 'HRMasterData']).then(res => {
        this.masterdata = res
        this.conditions[1].config.datasource.options = this.R.path(['listWorkingStatus'], this.masterdata) || []
        this.conditions[2].config.datasource.options = this.R.path(['listLevel'], this.masterdata) || []
      })
      this.$query(['MasterData', 'Department']).then(res => {
        let result = this._.values(this._.omit(res,'metaData'))
        this.conditions[0].config.datasource.options = result || []
      })
    },
    clearFilter() {
      this.filterDialog = false
      this.$nextTick(() => {
        for(let key in this.entitySelector) {
          this.entitySelector[key].data = null
          this.entitySelector[key].chipModel = null
          this.entitySelector[key].chipShow = false
        }
        this.search()
      })
    }
  }
}
</script>
